import * as React from "react";
import { forwardRef } from "react";
const SvgHeroiconsOutlineArrowSmLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.2427 7.75736L7.75743 16.2426M9.17165 7.75736H16.2427H9.17165ZM16.2427 7.75736V14.8284V7.75736Z", stroke: "#979797", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgHeroiconsOutlineArrowSmLeft);
export default ForwardRef;
